<template>
  <div class="tw-relative tw-mt-2 tw-flex tw-items-center tw-justify-center">
    <div
      class="tw-absolute tw-left-8 tw-top-0 tw-flex tw-items-center sm:tw-left-12"
    >
      <div class="-tw-mt-3.5 tw-text-dark-gray">
        <v-icon>mdi-arrow-up-left</v-icon>
      </div>
      <a
        href="/blog/schej-is-now-timeful/"
        class="tw-cursor-pointer tw-select-none tw-text-sm tw-text-dark-gray hover:tw-underline"
      >
        Formerly known as "Schej"
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: "FormerlyKnownAs",
}
</script>
